import client, { openAiClient } from "../config/axios";

export const updateTeacherSession = async (param) => {
  console.log("param ", param);
  const data = { plan: param.plan };
  const response = await client.put(`/teacher-session/${param.id}`, {
    ...data,
  });
  return response.data;
};

export const getSessionsByUseCase = async (useCase = "") => {
  const response = await client.get(
    `/teacher-session/use-case-list/${useCase}`
  );
  return response.data;
};

export const getTeacherSessions = async () => {
  const response = await client.get("/teacher-session/history/list");
  return response.data;
};

export const getSessionByUseCase = async (useCase = "") => {
  const response = await client.get(`/teacher-session/use-case/${useCase}`);
  return response.data;
};

export const getSessionById = async (id) => {
  const response = await client.get(`/teacher-session/${id}`);
  return response.data;
};

export const getIteractionById = async (id) => {
  console.trace();
  const response = await openAiClient.get(`/interactions/${id}`);
  const mapperMessages = response.data.data.messages
  .map((msgs) => {
    let content = msgs?.data?.content;
    let role = msgs?.type;
    if(msgs?.content?.length){
      content = msgs.content[0].text.value
      role = msgs.role;
    }
    return {
      role,
      content,
      createdAt: msgs?.created_at,
    }
  });
  const mapperHistoeryMessages = response.data?.history?.map((e) => {
    const currentMessages = e.messages
      .map((msgs) => ({
        role: msgs.type,
        content: msgs.data.content,
        createdAt: msgs?.created_at,
      }))
    const findOldMessages = mapperMessages.find(msg => ["assistant","user"].includes(msg?.type || msg?.role))
    return {
      ...e,
      superPower: e.super_power,
      messages: findOldMessages ? currentMessages.reverse(): currentMessages,
    };
  });
  const findOldMessages = mapperMessages.find(msg => ["assistant","user"].includes(msg?.type || msg?.role))
  return {
    data: {
      ...response.data.data,
      messages: findOldMessages ? mapperMessages.reverse() : mapperMessages,
      superPower: response.data.data.super_power,
      classProfile: response.data.data.class_profile,
    },
    history: mapperHistoeryMessages || [],
  };
};

export const getSessionsByClassProfile = async ({ id, page }) => {
  const response = await client.get(`/teacher-session/class-profile/${id}`, { params: { page } });
  return response.data;
};
